import { AppointmentsInterface } from '../../../interfaces/dto/appointments/appointments-interface';

export class CpAppointmentsModel implements AppointmentsInterface {
  appointmentStatus: string = '';
  dateRequested: string = '';
  encounterId: string = '';
  personName: string = '';
  subserviceName: string = '';

  // Propriedades internas privadas para os campos
  private _serviceName: string = '';
  private _specialtyName: string = '';

  private _fullServiceName: string = '';

  constructor(init?: Partial<CpAppointmentsModel>) {
    Object.assign(this, init);
    this.updateFullServiceName();
  }

  private updateFullServiceName(): void {
    this._fullServiceName = `${this._serviceName} - ${this._specialtyName}`;
  }

  get serviceName(): string {
    return this._serviceName;
  }

  set serviceName(value: string) {
    this._serviceName = value;
    this.updateFullServiceName();
  }

  get specialtyName(): string {
    return this._specialtyName;
  }

  set specialtyName(value: string) {
    this._specialtyName = value;
    this.updateFullServiceName();
  }

  get fullServiceName(): string {
    return this._fullServiceName;
  }
}
